export const OPCOES_TAMANHO_PAGINA = [4, 8, 20];

export const parsedSort = (sort, order) => {
  return `${sort},${order === "descend" ? "desc" : "asc"}`;
};